const Loading = () => {
    return (
        <div className="loading-indicator">
            <div />
            <div />
            <div />
            <div />
        </div>
    );
};

export default Loading;
